<template>
  <div class="con_content">
       <div class="container">
           <div class="container_top h_48">
                登录日志

                <div class="back_btn" @click="$router.back(-1)">
                    <Icon type="ios-arrow-back" />返回
                </div>
           </div>
           
           <!-- table组件 -->
            <div class="my_table">
                <Header class="my_title txt_l">
                    <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                        数据列表
                    </span>
                </Header>
                <Table border :columns="columns1" :data="data1"></Table>
                <Footer>
                    <Page  :current.sync="page" :total="toatalPage" :page-size='pageSize'    @on-change='changepage'  show-total  show-elevator />
                </Footer>
                
              
            </div>

       </div>
  </div>
</template>

<script>
  

    export default {
        name:'loginLog',
        data () {
            return {
                token:'',
                total:null,
                columns1:[],
                data1:[],
                toatalPage:0,
                page:1,
                pageCurrent:1,
                pageSize:20,

                checkGuid2:''
              
            }
        },
       
     
        computed: {
          
            
        },
        methods: {
           load(){
                var that = this;
                 // vuex
                that.token = that.$store.state.token;

              
               
                that.$ajax({
                
                    method:'get',
                    url: 'account/service/all/login/log?page='+that.page,
                    data: {},
                    
                }).then(res => {
                        
                    var total = res.data.data;
                    var list =res.data.data.list;
                    
                    that.total = total;
                    var len = list.length;
                    
                        
                    that.columns1 = [
                        {title:'时间',key:'createTime',align:'center'},
                        {title:'IP',key:'ip',align:'center'},
                        {title:'地区',key:'address',align:'center'},
                        {title:'浏览器',key:'browser',align:'center'},
                        
                    ];
                    that.data1 = list;

                    that.toatalPage = total.total;
                    that.pageSize = total.pageSize;
                  
                }).catch(err=>{
                    console.log(err)
                })

              
           },
           changepage(index){
               var that = this;
               that.load();
           }
           
            
        },
        mounted: function(){
           var that = this;
           that.checkGuid2 = that.$store.state.checkGuid2;
           that.load();
           
        }
    }
</script>
<style scoped>
   
    
</style>


